export enum IdentityProviderProtocol {
    SAML = 1,
    OIDC = 2,
}
